import { render, staticRenderFns } from "./QrCodeButton.vue?vue&type=template&id=ba6ede26&"
import script from "./QrCodeButton.vue?vue&type=script&lang=ts&"
export * from "./QrCodeButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports